export default __webpack_public_path__ + "static/media/louvre_lights_on.8b4baadd.jpg";